import { Injectable } from "@angular/core";

@Injectable()
export class OutdatedNotifierService {
  public isOutdatedForAPM(name: string, version: string): boolean {
    switch (name) {
      case "airbrake-ruby":
        if (version.startsWith("1.")) {
          return true;
        }
        if (version.startsWith("2.")) {
          return true;
        }
        if (version.startsWith("3.")) {
          return true;
        }
        if (/^4\.[0-7]\./.test(version)) {
          return true;
        }
        break;
      case "gobrake":
        if (version.startsWith("0")) {
          return true;
        }
        if (version.startsWith("1.")) {
          return true;
        }
        if (version.startsWith("2.")) {
          return true;
        }
        if (version.startsWith("3.")) {
          return true;
        }
        break;
      case "pybrake":
        if (version.startsWith("0.0.")) {
          return true;
        }
        if (version.startsWith("0.1.")) {
          return true;
        }
        if (version.startsWith("0.2.")) {
          return true;
        }
        if (version.startsWith("0.3.")) {
          return true;
        }
        break;
      case "airbrake-js":
        if (version.startsWith("0")) {
          return true;
        }
        if (/^1\.0\.[0-3]/.test(version)) {
          return true;
        }
        break;
    }

    return false;
  }
}
